import {
	Button,
	Dialog,
	DialogContent,
	DialogActions,
	Alert,
	CircularProgress,
	Backdrop,
} from "@mui/material";

import UploadFileIcon from "@mui/icons-material/UploadFile";

import { useState } from "react";

import { fileUpload } from "../../services/wapi";

export const FileUploadDialog = ({ visible, setVisibility, onSuccess }) => {
	const [isLoading, setLoading] = useState(false);

	const [showAlert, setShowAlert] = useState(false);

	const [uploadedFiles, setUploadedFiles] = useState([]);

	const onFileUpload = async (event) => {
		const { files } = event.currentTarget;

		setUploadedFiles([...uploadedFiles, ...Object.values(files)]);
	};

	const removeFile = async (idx) => {
		const currentFiles = uploadedFiles.filter((x, i) => i !== idx);
		setUploadedFiles(currentFiles);
	};

	const handleSubmit = async () => {
		const guids = [];

		try {
			setLoading(true);
			setShowAlert(false);

			for (const file of uploadedFiles) {
				const response = await fileUpload(file);

				response?.file &&
					Object.keys(response.file)?.[0] &&
					guids.push(Object.keys(response.file)[0]);
			}

			onSuccess(guids);
			setVisibility(false);
		} catch (ex) {
			setShowAlert(true);
		} finally {
			setLoading(false);
		}
	};

	return (
		<>
			<Backdrop open={isLoading} sx={{ zIndex: 99999 }}>
				<CircularProgress />
			</Backdrop>
			<Dialog
				open={visible}
				onClose={() => setVisibility(false)}
				className="bottom-sheet-modal"
			>
				<DialogContent style={{ paddingTop: "15px" }}>
					<strong>Upload a valid prescription</strong>
					<div className="my-2 d-flex justify-content-center flex-column align-items-center">
						{uploadedFiles.map((fileDetails, idx) => (
							<div
								key={idx}
								className="my-2 py-1 px-2"
								style={{
									backgroundColor: "#F6FFDF",
									width: "fit-content",
									position: "relative",
								}}
							>
								{fileDetails.name}
								<div
									style={{ position: "absolute", top: "-7px", right: "-7px" }}
									onClick={() => removeFile(idx)}
								>
									x
								</div>
							</div>
						))}
					</div>
					<div
						className="d-flex justify-content-center align-items-center border p-2"
						style={{ margin: "auto" }}
					>
						<input
							accept="image/*"
							style={{ display: "none" }}
							id="raised-button-file"
							multiple
							type="file"
							onChange={(e) => onFileUpload(e)}
						/>
						<label htmlFor="raised-button-file">
							<Button variant="raised" component="span">
								<UploadFileIcon />
								<strong>Rx UPLOAD</strong>
							</Button>
						</label>
					</div>
				</DialogContent>
				<DialogActions>
					<Button
						fullWidth
						variant="contained"
						color="primary"
						onClick={handleSubmit}
					>
						SUBMIT
					</Button>
				</DialogActions>

				{!isLoading && showAlert && (
					<Alert severity="error" sx={{ marginTop: "20px" }}>
						{"Something went wrong, Please try again"}
					</Alert>
				)}
			</Dialog>
		</>
	);
};
